import _cloneDeep from 'lodash/cloneDeep';

/**
 * Remove empty & null values from nested object (ES6) - Clean nested Objects
 * https://stackoverflow.com/a/52368116
 * @param  {Object} object
 */
export function clean(oldObject) {
    // Create deep copy
    let object = _cloneDeep(oldObject);

    Object.entries(object).forEach(([k, v]) => {
        let nV = v;

        // If nested, process child first
        if (v && typeof v === 'object') nV = clean(v);

        if (
            (nV && typeof nV === 'object' && !Object.keys(nV).length) || // If is object and it does not have any properties
            nV === null ||
            nV === undefined
        ) {
            if (Array.isArray(object)) object.splice(k, 1);
            else delete object[k];
        }
    });

    return object;
}
